import { Dialog, DialogContent, ThemeProvider } from "@mui/material"
import { PaperArrastavel } from "../dialog-arrastavel/PaperArrastavel"
import React, { useCallback } from "react"
import { AlterarSenhaVendedorContainerDialog } from "../alterar-senha-vendedor/AlterarSenhaVendedorContainerDialog"
import { IniciarOrcamentoContainerDialog } from "../iniciar-orcamento/IniciarOrcamentoContainerDialog"
import { theme } from "../materialUiTheme"
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { SenhaVendedorContainer } from "./SenhaVendedorContainer"

export type SenhaVendedorContainerDialogProps = {
    tipoOrcamento?: string
    onRenderizarAposAutentificar?: () => void
    onVoltar?: () => void
}

export const SenhaVendedorContainerDialog = (props: SenhaVendedorContainerDialogProps) => {
    const handleCancelar = useCallback(() => {
        removerComponenteReact("senha-vendedor-container-dialog")
        props.onVoltar?.()
    }, [props.onVoltar])

    const handleAutenticado = useCallback(() => {
        removerComponenteReact("senha-vendedor-container-dialog")
        if (props.onRenderizarAposAutentificar) {
            props.onRenderizarAposAutentificar()
        } else {
            renderizarComponentReact(
                <IniciarOrcamentoContainerDialog tipoOrcamento={props.tipoOrcamento} />, 
                "iniciar-orcamento-container-dialog", 
                false
            )
        }
    }, [props.onRenderizarAposAutentificar, props.tipoOrcamento])

    const handleAlterarSenha = useCallback(() => {
        removerComponenteReact("senha-vendedor-container-dialog")
        renderizarComponentReact(AlterarSenhaVendedorContainerDialog, "alterar-senha-vendedor-container-dialog", false)
    }, [])

    return (
        <ThemeProvider theme={theme}>
            <Dialog open={true} fullScreen PaperComponent={PaperArrastavel}>
                <DialogContent>
                    <div className="_flex _justify-center _w-full _mt-24">
                        <SenhaVendedorContainer
                            onCancelar={handleCancelar}
                            onAutenticado={handleAutenticado}
                            onAlterarSenha={handleAlterarSenha}
                        />
                    </div>
                </DialogContent>
            </Dialog>
        </ThemeProvider>
    )
}

(window as any).SenhaVendedorContainerDialog = SenhaVendedorContainerDialog
